import TeamCarouselItem from './item';
import type { Attorney } from '@jlg-website/database/types';
import Cta from '@/components/pages/cta';
import { ChevronLeft, ChevronRight } from '@/components/pages/icons';
import type { EmblaViewportRefType, UseEmblaCarouselType } from 'embla-carousel-react';

type TeamCarouselServerProps = {
  attorneys: Attorney[];
  canScrollPrev?: boolean;
  canScrollNext?: boolean;
  emblaRef?: EmblaViewportRefType;
  emblaApi?: UseEmblaCarouselType[1];
  className?: string;
  showLinks?: boolean;
};

export function TeamCarouselServer({
  attorneys,
  emblaRef,
  canScrollPrev,
  canScrollNext,
  emblaApi,
  showLinks,
}: TeamCarouselServerProps) {
  return (
    <div className="flex flex-col justify-center">
      <div className="overflow-hidden pl-4 @lg:pl-carousel pr-4 @lg:pr-8" ref={emblaRef}>
        <div className="flex gap-4">
          {attorneys.map((member) => (
            <TeamCarouselItem key={member.id} member={member} showLink={showLinks} />
          ))}
        </div>
      </div>

      <div
        className={`flex items-center @lg:pt-8 ${showLinks ? 'justify-between' : 'justify-end'} pl-4 @lg:pl-carousel pr-4 @lg:pr-8`}
      >
        {showLinks && (
          <Cta
            variation="outline"
            text="See the whole team"
            href="#"
            className="w-full @lg:w-auto"
          />
        )}

        <div className="hidden @lg:flex gap-2">
          <button
            onClick={emblaApi ? () => emblaApi?.scrollPrev() : undefined}
            disabled={!canScrollPrev}
            className={`w-12 h-12 rounded-full flex items-center justify-center transition-all duration-200 bg-brand-muted-light
              ${
                canScrollPrev
                  ? 'hover:brightness-90 cursor-pointer'
                  : 'opacity-60 cursor-not-allowed'
              }`}
          >
            <ChevronLeft className="w-4.5 h-4.5" />
          </button>
          <button
            onClick={emblaApi ? () => emblaApi?.scrollNext() : undefined}
            disabled={!canScrollNext}
            className={`w-12 h-12 rounded-full flex items-center justify-center transition-all duration-200 bg-brand-muted-light
              ${
                canScrollNext
                  ? 'hover:brightness-90 cursor-pointer'
                  : 'opacity-60 cursor-not-allowed'
              }`}
          >
            <ChevronRight className="w-4.5 h-4.5" />
          </button>
        </div>
      </div>
    </div>
  );
}
